<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom mb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Class Room Request</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #classroomdetailreq="ngForm" (ngSubmit)="onSubmit(data)" class="pb-3">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label><b>Total available classrooms</b><span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #NoOfClassRoom="ngModel" ngModel
                                        name="NoOfClassRoom" [(ngModel)]="data.NoOfClassRoom" maxlength="20"
                                        (keyup)="fillClassRooms()" numbersOnly
                                        placeholder="Enter total available classrooms" required>
                                    <span *ngIf="classroomdetailreq.submitted && NoOfClassRoom.invalid">
                                        <p *ngIf="NoOfClassRoom.errors.required" class="error_message"
                                            style="color: red;">
                                            Total available classrooms is required
                                        </p>
                                    </span>
                                   
                                    </div>
                                </div>
                            </div>
                            <div id="divClassRoom" style="width: 100%;">
                                    
                            </div>
                           
                            <div class="mb-3">
                                <button class="btn btn-success" type="submit"
                                    style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" (click)="resetForm()"
                                    style="margin: 5px;">Clear</button>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div class="col-lg-12 col-md-12 col-12">
                                        <div class="row">
                                            <div class="col-md-11">
                                                <div class="py-3">
                                                    <input type="text" id="searchtext" class="form-control bg-white border-0 small"
                                                        placeholder="Search for..." [(ngModel)]="searchtext" aria-label="Search"
                                                        aria-describedby="basic-addon2" />
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="py-3">
                                                <button class="btn btn-success" (click)="GetClassRoomList(1);"
                                                    style="margin: 5px;">Search</button>
                                                    </div>
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. no.
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('RequestDate')">
                                                        Request date</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('NoOfClassRoom')">
                                                        No Of Classroom</th>
                                                        <th class="pointer" scope="col"
                                                        (click)="sortBy('ClassRoomName')">Class Room Details (Class Room Name - Class Room Size)</th>
                                                        <th class="pointer" scope="col" (click)="sortBy('Status')">Status
                                                        </th>
                                                        <th class="pointer" scope="col" (click)="sortBy('Remark')">Admin
                                                            remark</th>
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                *ngIf="ClassRoomRequestList != undefined && ClassRoomRequestList.length != 0">
                                                <tr
                                                    *ngFor="let r of ClassRoomRequestList  | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalClass};let i = index">
                                                    <td>
                                                        <p>{{r.SrNo}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.RequestDate}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.NoOfClassRoom}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.ClassRoomName}}</p>
                                                    </td>
                                                    <td>
                                                        <p *ngIf="r.Status == 0"
                                                            style="color: black;font-weight: bold;">Pending</p>
                                                        <p *ngIf="r.Status == 1"
                                                            style="color: green;font-weight: bold;">Approved</p>
                                                        <p *ngIf="r.Status == 2" style="color: red;font-weight: bold;">
                                                            Rejected</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Remark}}</p>
                                                    </td>
                                                    <td>
                                                        <button type="button" class="btn btn-success rmb_10" *ngIf="r.Status == 2"
                                                            (click)="editClassRoomRequest(r.HashCode)">Edit</button>
                                                        &nbsp; <button type="button" class="btn btn-danger" *ngIf="r.Status == 0"
                                                            (click)="deleteClassRoomRequest(r.HashCode)">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody
                                                *ngIf="ClassRoomRequestList == undefined || ClassRoomRequestList.length == 0">
                                                <tr>
                                                    <td colspan="10" style="text-align: center;"> No Record Found </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="card-footer pb-0 pt-3" align="right" *ngIf="ClassRoomRequestList != undefined && ClassRoomRequestList.length != 0">
                                            <pagination-controls (pageChange)="GetClassRoomList($event)" responsive="true"
                                            maxSize="{{totalPages}}"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-login custom-footer">
            <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
            <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
        </div>
        <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white;">Please Wait.</p>
        </ngx-spinner>
    </div>